import { Component, Input } from '@angular/core'

@Component({
	selector: 'app-company-logo',
	templateUrl: './company-logo.component.html',
	styleUrl: './company-logo.component.scss',
})
export class CompanyLogoComponent {
	@Input() logoWidth: string = '30px'
	@Input() logoHeight: string = '30px'
	@Input() symbol: string | undefined | null = null
	@Input() logoSrc: string | undefined | null = null
	@Input() logoAlt: string | undefined | null = null
}
